<template>
  <liste-template>
    <template #header>
      <h1 class="title is-size-3">{{ $t('listBonExpedition.title')}}</h1>
      <breadcrumb :breadcrumb="breadcrumb"/>
    </template>
    <template #before-bar>
      <onglet-list/>
    </template>
    <template #bar-left>
      <div class="column is-narrow">
        <selecteur-action
          @handleAction="handleAction"
          :options="actions"
          :placeholder="$t('general.placeHolder.groupedAction')"
          :elementsSelectionnes="hasASelection"
          titleButton="general.button.apply">
        </selecteur-action>
      </div>
      <form
        @submit.prevent="recherche()"
        class="column is-6 pdr-0">
        <b-input
          :placeholder="$t('general.button.search')"
          type="search"
          icon="magnify"
          v-model="criteresRecherche.auto">
        </b-input>
      </form>
      <div class="column is-narrow">
        <button class="button" @click="setShowFiltre">
          <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
          <span class="is-size-7">
            {{$t('general.button.filtre')}}
            <label
              :class="nombreCritere > 0 ? '' : 'is-invisible'"
              class="has-text-weight-bold">
              ({{ nombreCritere }})
            </label>
          </span>
        </button>
        <span
          @click="reinitialiserFiltre()"
          class="info-circle-right is-pulled-right is-cursor-pointer">
          <b-icon icon="close-circle" type="is-danger"></b-icon>
        </span>
      </div>
    </template>
    <template #bar-right>
      <div class="column is-narrow">
        <exportExcelButton
          :perm="constantes.BON_EXPEDITION.exporter"
          :query="exportExcelQuery"/>
      </div>
      <parametrage-table
        :reference-table="referenceTable"
        @endLoadParamtre="finChargement = true">
      </parametrage-table>
    </template>
    <template #content>
      <v-server-table
        v-if="finChargement"
        :columns="getColumns"
        :options="options"
        :ref="referenceTable"
        @loaded="finLoading"
        @loading="debutLoading"
        url="">
        <template #selected="{ row }">
          <b-checkbox
            :value="row.selected"
            @input="selectionBonExpedition(row, $event)"
            class="has-text-centered">
          </b-checkbox>
        </template>
        <template slot="afterTable">
          <table-items-in-view
            :perPage="resultPerPage"
            @input="$refs[referenceTable].setLimit($event)" />
        </template>
        <template #dateBonExpedition="{ row }">
          <router-link
            :to="{ name: 'c.logistique.bon_expedition', params: { id: row.id } }"
            :class="{
              'text-access-no-permission': !checkPermissions(constantes.BON_EXPEDITION.lecture)
            }"
            class="lien">
            {{ func.formatDate(row.dateBonExpedition) }}
          </router-link>
        </template>
        <template #nomDestination="{ row }">
          {{ nomDestinataire(row) }}
        </template>
        <template #adresseExpedition="{ row }">
          {{ func.adressFullStringGetter(row.adresseExpedition, false, true) }}
        </template>
        <template #nombreElementColis="{ row }">
          {{ row.nombreElementColis }}
        </template>
        <template #poidsParColis="{ row }">
          {{ row.poidsParColis }}
        </template>
        <template #edit="{ row }">
          <div class="has-text-centered">
            <btn-action-icon
              :permission="constantes.BON_EXPEDITION.maj"
              @is-click="$router.push({ name: 'm.logistique.bon_expedition', params: {id: row.id}})"
              icon-type="is-success"
              icon="pencil-box-outline">
            </btn-action-icon>
          </div>
        </template>
        <template #archiver>
          <div class="has-text-centered">
            <btn-action-icon
              :permission="constantes.BON_EXPEDITION.supprimer"
              @is-click="func.inProgress($i18n)"
              icon-type="is-default"
              :icon="'archive'">
            </btn-action-icon>
          </div>
        </template>
        <template #delete>
          <div class="has-text-centered">
            <btn-action-icon
              :permission="constantes.BON_EXPEDITION.supprimer"
              @is-click="func.inProgress($i18n)"
              icon-type="is-danger"
              icon="delete-forever">
            </btn-action-icon>
          </div>
        </template>
      </v-server-table>
    </template>
    <template #filter>
      <div class="componentBrief" v-show="showFiltre">
        <filtre-bon-expedition
          ref="filtreListeBonExpedition"
          @toggleFiltre="setShowFiltre"
          @recherche="makeRechercheFilter"/>
      </div>
    </template>
  </liste-template>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { createNamespacedHelpers } from 'vuex';
import Breadcrumb from '@/components/general/breadcrumb';
import BtnActionIcon from '@/components/general/btnActionIcon';
import ParametrageTable from '@/components/general/parametrageTable';
import TableItemsInView from '@/components/general/TableItemsInView';
import ListeTemplate from '@/components/general/template/listeTemplate';
import ExportExcelButton from '@/components/general/button/exportExcelButton';
import OngletList from '@/components/logistique/bonExpedition/list/ongletList';
import FiltreBonExpedition from '@/components/logistique/bonExpedition/list/filtreBonExpedition';
import formatDate from '@/services/general/formatDate';
import inProgress from '@/services/general/inProgress';
import messageErreur from '@/services/general/messageErreur';
import subscribeMutation from '@/services/store/subscribeMutation';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import { BON_EXPEDITION } from '@/configuration/logistique/permissionsLogistiqueConf';
import { REFERENCE_TABLE_LISTE_BON_EXPEDITION } from '@/configuration/general/referenceTableConf';
import { SET_CRITERES } from '@/store/modules/logistique/bonExpedition-mutation-type';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import selecteurAction from '@/components/general/selecteurAction';
import { TYPE_PDF } from '@/configuration/edition/editionConf';
import { ACTION_EDITION_BON_LIVRAISON } from '@/configuration/logistique/ordreTravail/ordreTravailConf';
import { editionOts } from '@/services/logistique/ordreTravail/expedition/bonExpeditionService';
import formatIsoDate from '@/services/general/formatIsoDate';
import genererCritereRecherche from '@/services/logistique/bonExpedition/genererCritereRecherche';

const Societe = createNamespacedHelpers('societe');
const Permissions = createNamespacedHelpers('permissions');
const BonExpedition = createNamespacedHelpers('bonExpedition');

export default {
  name: 'l_bonExpedition',
  components: {
    Breadcrumb,
    OngletList,
    BtnActionIcon,
    ListeTemplate,
    ExportExcelButton,
    TableItemsInView,
    ParametrageTable,
    FiltreBonExpedition,
    selecteurAction,
  },
  data() {
    return {
      constantes: {
        BON_EXPEDITION,
      },
      func: {
        formatDate,
        inProgress,
        adressFullStringGetter,
      },
      resultPerPage: RESULTS_PER_PAGE,
      finChargement: false,
      showFiltre: false,
      referenceTable: REFERENCE_TABLE_LISTE_BON_EXPEDITION,
    };
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      lockMenu: 'lockMenu',
    }),
    ...BonExpedition.mapGetters({
      total: 'total',
      bonExpeditions: 'items',
      lastPayload: 'lastPayload',
      criteresRecherche: 'critereRecherche',
    }),
    breadcrumb() {
      return [
        { title: this.$i18n.t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('listBonExpedition.title'), route: { name: '' }, isActive: true },
      ];
    },
    columns() {
      return [
        {
          name: 'selected',
          text: '',
          show: true,
          sortable: false,
        },
        {
          name: 'dateBonExpedition',
          text: 'listBonExpedition.table.dateExpedition',
          show: true,
          sortable: true,
        },
        {
          name: 'nomDestination',
          text: 'listBonExpedition.table.nomDestination',
          show: true,
          sortable: false,
        },
        {
          name: 'adresseExpedition',
          text: 'listBonExpedition.table.adresseExpedition',
          show: true,
          sortable: true,
        },
        {
          name: 'nombreElementColis',
          text: 'listBonExpedition.table.nombreElementColis',
          show: true,
          sortable: true,
        },
        {
          name: 'poidsParColis',
          text: 'listBonExpedition.table.poidsParColis',
          show: true,
          sortable: true,
        },
        {
          name: 'edit',
          text: '',
          show: true,
          sortable: false,
        },
        {
          name: 'archiver',
          text: '',
          show: true,
          sortable: false,
        },
        {
          name: 'delete',
          text: '',
          show: true,
          sortable: false,
        },
      ];
    },
    iconSelectTotal() {
      if (this.allBonExpeditionSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    getHeadings() {
      return this.columns.filter(c => c.name !== 'selected').reduce((old, a) => ({ ...old, [a.name]: this.$i18n.t(a.text) }), {
        selected: (h) => {
          return h(
            'a', {
              attrs: {
                class: 'pointer',
              },
              on: {
                click: () => {
                  this.selectAll();
                },
              },
            },
            [
              h('b-icon', {
                attrs: {
                  icon: this.iconSelectTotal,
                },
              }),
            ],
          );
        },
      });
    },
    getSortable() {
      return this.columns.filter(c => c.sortable).map(c => c.name);
    },
    getColumns() {
      return this.columns.filter(c => c.show).map(c => c.name);
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: this.getHeadings,
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        sortable: this.getSortable,
        columnsClasses: {
          dateSignature: 'colonneWith180',
          dateEnvoie: 'colonneWith180',
          contratEtatSignature: 'colonneWith180',
          selected: 'colonneSelected',
        },
        requestFunction: ((data) => {
          if (!data.query) data.query = cloneDeep(this.criteresRecherche);
          data.query.societeId = this.societeActiveId;
          if (this.criteresRecherche.dates) {
            data.query.dates.dateDebut = formatIsoDate(
              data.query.dates.dateDebut,
            );
            data.query.dates.dateFin = formatIsoDate(
              data.query.dates.dateFin,
            );
          }
          data.query.destinataireIds = this.criteresRecherche.destinataireIds
            .map(contact => contact.id);
          return this.actionsLoad(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.bonExpeditions,
            count: this.total,
          };
        }),
      };
    },
    nombreCritere() {
      let nombreCritere = 0;
      const banCritere = ['auto', 'societeId', 'dates'];
      nombreCritere = calculNombreCritere(this.criteresRecherche, banCritere);
      if (
        !!this.criteresRecherche.dates?.dateDebut
        || !!this.criteresRecherche.dates.dateFin) nombreCritere += 1;
      return nombreCritere <= 9 ? nombreCritere : '+9';
    },
    actions() {
      const actions = [{
        action: ACTION_EDITION_BON_LIVRAISON,
        translation: 'listeOrdreTravailTech.actions.bonLivraison',
      }];
      return actions;
    },
    hasASelection() {
      return this.bonExpeditions.some(be => be.selected);
    },
    allBonExpeditionSelected() {
      return this.getAllBonExpeditionSelected().length === this.bonExpeditions.length;
    },
    exportExcelQuery() {
      return {
        typeDonnee: 'bonexpedition',
        typeExport: null,
        filtres: this.lastPayload,
      };
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...BonExpedition.mapActions({
      actionsLoad: 'loadBonExpedition',
    }),
    ...BonExpedition.mapMutations({
      setCritereRecherche: SET_CRITERES,
    }),
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    goFirstPage() {
      this.$refs[this.referenceTable].setPage(1);
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) this.$refs.filtreListeBonExpedition.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    async reinitialiserFiltre() {
      await this.$refs.filtreListeBonExpedition.viderCritere();
      await this.$refs.filtreListeBonExpedition.appliquerCritere();
      this.showFiltre = false;
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    nomDestinataire(row) {
      return [
        row.prenomContactDestinataire,
        row.nomContactDestinataire,
      ].filter(Boolean).join(' ');
    },
    goFirstPageAndCheckChangement() {
      this.$refs[this.referenceTable].setPage(1);
    },
    selectAll() {
      const select = !this.allBonExpeditionSelected;
      this.bonExpeditions.forEach((el) => {
        el.selected = select;
      });
    },
    getAllBonExpeditionSelected() {
      return this.bonExpeditions.filter((el) => {
        return el.selected;
      });
    },
    handleAction(action) {
      switch (action) {
        case ACTION_EDITION_BON_LIVRAISON:
          this.applyEditionBonLivraison();
          break;
        default:
          break;
      }
    },
    async applyEditionBonLivraison() {
      if (!this.checkPermissions(this.constantes.BON_EXPEDITION.editer)) {
        this.showPopUp();
        return;
      }
      const otIds = this.bonExpeditions
        .filter(be => be.selected)
        .flatMap(be => be.otImpressionsIds);
      const loadingComponent = this.$buefy.loading.open();
      try {
        await editionOts(otIds, TYPE_PDF);
      } catch (e) {
        messageErreur(this.$i18n);
        throw (e);
      } finally {
        loadingComponent.close();
      }
    },
    selectionBonExpedition(row, newValue) {
      const bonExpedition = this.bonExpeditions.find((_bonExpedition) => {
        return _bonExpedition.id === row.id;
      });
      bonExpedition.selected = newValue;
    },
  },
  beforeDestroy() {
    if (this.lockMenu) this.setLockMenu(false);
    this.setCritereRecherche(genererCritereRecherche());
    this.unsubscribeValue();
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.goFirstPageAndCheckChangement, this.recherche);
      const critere = cloneDeep(this.criteresRecherche);
      this.setCritereRecherche(critere);
      this.setInformationPage(this.$t('pageLogistique.ot.listBonExpedition'));
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    } finally {
      loadingComponent.close();
    }
  },
};
</script>

<style>

</style>
